import Template from "app/models/template"
import { Action, Types } from "./templates.actions"

export type Params = {
  sort: string[]
}

export type TemplatesState = {
  data: Template[]
  errors: {}
  loading: boolean
  template: Template | undefined
  params?: Params
}

const initialState: TemplatesState = {
  data: [],
  errors: {},
  loading: false,
  template: undefined,
  params: { sort: ["name=asc"] },
}

export default (state = initialState, action: Action): TemplatesState => {
  switch (action.type) {
    case Types.GET:
      return {
        ...state,
        data: [],
        params: action.payload.params,
        loading: true,
      }

    case Types.GET_SUCCESS:
      return {
        ...state,
        data: action.payload.data!,
        loading: false,
      }

    case Types.GET_FAIL:
      return {
        ...state,
        errors: action.payload.errors,
        loading: false,
      }

    case Types.DELETE:
      return {
        ...state,
        loading: true,
      }

    case Types.DELETE_SUCCESS:
      return {
        ...state,
        loading: false,
      }

    case Types.DELETE_FAIL:
      return {
        ...state,
        errors: action.payload.errors,
        loading: false,
      }

    case Types.POST:
      return {
        ...state,
        loading: true,
      }
    case Types.GET_BY_ID:
      return {
        ...state,
        loading: true,
      }

    case Types.POST_SUCCESS:
      return {
        ...state,
        loading: false,
        template: action.payload.data,
      }

    case Types.POST_FAIL:
      return {
        ...state,
        errors: action.payload.errors,
        loading: false,
      }

    case Types.GET_BY_ID_SUCCESS:
      return {
        ...state,
        loading: false,
        template: action.payload.data,
      }

    case Types.GET_BY_ID_FAIL:
      return {
        ...state,
        errors: action.payload.errors,
        loading: false,
      }

    case Types.PUT:
      return {
        ...state,
      }

    case Types.PUT_SUCCESS:
      return {
        ...state,
        template: action.payload.data,
      }

    case Types.PUT_FAIL:
      return {
        ...state,
        errors: action.payload.errors,
      }

    case Types.DUPLICATE_SUCCESS:
      return {
        ...state,
        data: [...state.data, action.payload.data],
      }

    default:
      return state
  }
}
